<template>
  <v-layout text-center>
    <v-container>
      <v-layout row>
        <v-flex xs12 sm8 offset-sm2>
          <v-card>
            <v-toolbar color="blue" dark>
              <v-toolbar-title>Text Messages</v-toolbar-title>
            </v-toolbar>

            <v-list two-line>
              <template v-for="(textMessage, index) in textMessages">
                <v-list-tile
                  :key="textMessage.carrier"
                  avatar
                  ripple
                >
                  <v-list-tile-action class="hidden-sm-and-down">
                    <v-btn color="error" @click="sendText(textMessage)">Send</v-btn>
                  </v-list-tile-action>

                  <v-list-tile-content class="hidden-sm-and-down pl-3">
                    <v-list-tile-title>{{ textMessage.title }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ textMessage.message }}</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-content class="hidden-md-and-up">
                    <v-btn color="error" @click="sendText(textMessage)">{{ textMessage.title }}</v-btn>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon
                      color="grey lighten-1"
                      @click="editText(textMessage)"
                    >
                      mdi-pencil
                    </v-icon>

                  </v-list-tile-action>

                </v-list-tile>
                <v-divider
                  v-if="index + 1 < textMessages.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="dialog = !dialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="text.id">Edit Text Message</v-toolbar-title>
          <v-toolbar-title v-else>Add Text Message</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn v-if="text.id > 0" dark flat @click="updateText">Update</v-btn>
            <v-btn v-else dark flat @click="saveText">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="text.title"
                  label="Title"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="text.message"
                  label="Message"
                  prepend-icon="notes"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card v-if="text.id" class="px-5">
          <v-card-title primary-title>
            <div>
              <div class="title">Distribution List</div>
            </div>
          </v-card-title>

          <v-card-text>
            <v-list two-line>
              <template v-for="(item, index) in text.Users">
                <v-divider
                  v-if="item.divider"
                  :key="index"
                  :inset="item.inset"
                ></v-divider>

                <v-list-tile
                  v-else
                  :key="item.title"
                  avatar
                >
                  <v-list-tile-avatar>
                    <img :src="item.picture">
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.firstName }} {{ item.lastName }}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-btn icon ripple @click="deleteMember(item.id)">
                      <v-icon color="red lighten-1">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-card-text>

          <v-card-actions>
            <v-autocomplete
              :items="users"
              v-model="user"
              label="New Member - * Must have Mobile Type assigned"
              hide-details
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-btn flat @click="addMember">Add Member</v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  data: () => ({
    currentPage: 'Text Messages',
    userId: 0,
    dialog: false,
    // myId: this.$store.state.user.id,
    isAdmin: false,
    textMessages: [],
    text: {},
    users: [],
    user: {},
    snackbar: {
      show: false,
      color: '',
      message: ''
    }
  }),

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear
    this.isAdmin = this.$store.state.isAdmin
    this.userId = this.$store.state.user.id

    this.getTexts()
    this.getUsers()
  },

  watch: {
    dialog (val) {
      if (!val) {
        this.text = {}
      }
    }
  },

  methods: {
    async getTexts () {
      try {
        const response = await Api().get('texts')
        this.textMessages = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getUsers () {
      try {
        const response = await Api().get('mobile_users')
        this.users = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    editText (text) {
      this.text = text
      this.dialog = true
    },

    async saveText () {
      try {
        const response = await Api().post('texts', this.text)

        this.textMessages.push(response.data.mobile)

        this.dialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateText () {
      try {
        const response = await Api().put('texts', this.text)

        this.dialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async sendText (textMessage) {
      textMessage.myEmail = this.$store.state.user.email

      try {
        const response = await Api().post('send_text', textMessage)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addMember () {
      try {
        const member = {}

        const user = await Api().get('users/' + this.user)
        console.log('user', user)

        let phone = user.data.cellPhone.replace(/[^+\d]+/g, '')

        const textAddress = phone + user.data.MobileType.extension

        member.textAddress = textAddress
        member.userId = this.user
        member.userTextId = this.text.id

        const response = await Api().post('text_member', member)

        this.text.Users.push(user.data)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteMember (userId) {
      let r = confirm('Are you sure you want to remove this member?')

      if (r === true) {
        try {
          const response = await Api().delete('text_member/' + userId + '/' + this.text.id)

          this.text.Users.splice(this.text.Users.findIndex(obj => obj.id === userId), 1)

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/texting/List.vue